"use client"
import { Button } from "@/components/Primitives/Button"
import { Text } from "@/components/Primitives/Text"
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalClose,
} from "@/components/Primitives/Modal/modal"
import { Spinner } from "@/components/Primitives/Spinner"
import { useConfig } from "@/hooks/useConfig"

interface DeleteAccountModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteAccountModal({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteAccountModalProps) {
  const { t } = useConfig()

  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent>
        <ModalHeader>
          <div className="flex justify-end items-center">
            <ModalClose className="right-0 top-0" />
          </div>
          <div className="flex flex-col items-center">
            <img src="/images/delete.png" alt="" width={80} height={80} />
            <Text variant="lead" bold className="mt-10 text-center">
              {t("config_profile_delete_account_title")}
            </Text>
          </div>
        </ModalHeader>
        <div className="flex flex-col gap-4">
          <Text variant="paragraph" className="text-center">
            {t("config_profile_delete_account_warning")}
          </Text>
          <div className="flex gap-4 justify-between mt-6">
            <Button
              variant="secondary"
              onClick={onClose}
              disabled={isDeleting}
              className="flex-1 justify-center"
            >
              {t("config_profile_delete_account_cancel")}
            </Button>
            <Button
              variant="destructive"
              onClick={onConfirm}
              disabled={isDeleting}
              className="flex-1 justify-center px-2"
            >
              {isDeleting && <Spinner className="w-4 h-4 animate-spin" />}
              {t("config_mission_delete_account_confirmation")}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}
